import { defineStore } from 'pinia';

export const useRedoUndoStore = defineStore({
  id: 'redo_undo_store',
  state: () => ({
    undoRecords: [],
    redoRecords: [],
  }),
});
